import React, { useState, useEffect, useCallback } from "react";
import { producaov2 } from "../../../../services/apis";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { convertDate } from "../../../../utils/Utils";
import Loading from "../../../../components/Loader";
import {
  Grid,
  Pagination,
  Button,
  FormGroup,
  Form as SUForm,
  Segment,
  Dropdown,
} from "semantic-ui-react";
import Menu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import swal from "sweetalert";
import {
  Container,
  Form,
  SearchBox,
  SearchBar,
  SearchButton,
  SearchOptions,
  SelectTitle,
  Select,
  Table,
  Line,
  Item,
  Space,
  Center,
  ActionsBar,
} from "./styles";

import "react-toastify/dist/ReactToastify.css";
import { isAuthAdmin } from "../../../../services/auth";
import CursosSelector from "../../../../components/Admin/CursosSelector";

toast.configure();
const DadosAlunosCursoStatus = () => {
  const [listAlunos, setListAlunos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id_curso, setIdCurso] = useState(null);
  const [status, setStatus] = useState(1);
  const [total, setTotal] = useState(0);
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [column, setColumn] = useState("nome");
  const [direction, setDirection] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [relatorioExcel, setRelatorioExcel] = useState(false);
  const statusOptions = [
    { key: 0, text: "Confirmação de Pagamento", value: 0 },
    { key: 3, text: "Não Iniciado", value: 3 },
    { key: 1, text: "Em Andamento", value: 1 },
    { key: 2, text: "Concluído", value: 2 },
    { key: 5, text: "Estorno", value: 5 },
  ];

  const submitSearch = (event) => {
    if (event) event.preventDefault();

    if (!id_curso) {
      return false;
    }

    setLoading(true);
    setListAlunos([]);
    const searchDate = formatDate(dateStart, dateEnd);

    producaov2
      .get(
        `/dados_aluno_status/${id_curso}/${status}?page=${page}&${searchDate}`,
        {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        }
      )
      .then((response) => {
        let logs = {
          local: "analytic/DadosAlunoCurso",
          texto: `Listou os alunos do curso ${id_curso}`,
        };
        producaov2.post("system_logs", { acao: JSON.stringify(logs) });
        const { total, alunos, page, pages } = response.data;

        setListAlunos(alunos);
        setTotal(total);
        setPage(page);
        setTotalPages(pages);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setListAlunos([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadAuth();
    submitSearch();
  }, [status, page]);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const formatDate = (start, end) => {
    if (!start || !end) return "";
    return `dateStart=${start}&dateEnd=${end}`;
  };

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorioExcel(false);

    const errorController = { error: false };
    if (!dateStart && !dateEnd) {
      swal("Por favor, informe uma data de início e fim");
      return;
    }
    await producaov2
      .post("/admin/reports/analytic-dados-aluno-por-cursos", {
        data_inicio: dateStart,
        data_final: dateEnd,
        id_curso: id_curso,
        status: status,
      })
      .then((res) => {
        setRelatorioExcel(res.data.url);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio entre ${dateStart} e ${dateEnd}}`,
        });

        producaov2.post("system_logs", { acao });
        setLoading(false);
      })
      .catch((error) => {
        errorController.error = true;

        if (!error.response) {
          return;
        }

        swal(
          `Algo deu errado na geração do relatório em Excel`,
          `Se persistir, contate nosso suporte`,
          "error"
        );
      });
  });

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <Menu />
      <Container>
        <Form onSubmit={(e) => submitSearch(e)}>
          <Segment>
            <SUForm>
              <Grid stackable columns={2}>
                <Grid.Column>
                  <SUForm.Field>
                    <CursosSelector handleChange={setIdCurso} />
                  </SUForm.Field>
                  <SUForm.Input
                    label="De"
                    type="date"
                    value={dateStart}
                    onChange={(e) => setDateStart(e.target.value)}
                    fluid
                  />
                </Grid.Column>
                <Grid.Column>
                  <SUForm.Field>
                    <label>Status</label>
                    <Dropdown
                      placeholder="Selecione o status"
                      fluid
                      selection
                      options={statusOptions}
                      value={status}
                      onChange={(e, { value }) => setStatus(value)}
                      clearable
                    />
                  </SUForm.Field>
                  <SUForm.Input
                    label="Até"
                    type="date"
                    value={dateEnd}
                    onChange={(e) => setDateEnd(e.target.value)}
                    fluid
                  />
                  <div style={{ textAlign: "right", marginTop: 8 }}>
                    <Button primary disabled={!id_curso} type="submit">
                      Buscar
                    </Button>
                  </div>
                </Grid.Column>
              </Grid>
            </SUForm>
          </Segment>
        </Form>

        {listAlunos.length > 0 ? (
          <>
            <ActionsBar>
              <div> Total de Registros: {total} </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <Button
                  color="orange"
                  onClick={handleGenerateReport}
                  loading={loading}
                >
                  Gerar Relatório
                </Button>
                {relatorioExcel && (
                  <Button
                    style={{ minWidth: "80px" }}
                    onClick={() =>
                      relatorioExcel && window.open(relatorioExcel, "_blank")
                    }
                    color="green"
                  >
                    Baixar Relatório Excel
                  </Button>
                )}
              </div>
            </ActionsBar>
            <Table>
              <Line>
                <Item>ID PESSOA</Item>
                <Item
                  onClick={() => {
                    setColumn("nome");
                    setDirection(!direction);
                  }}
                >
                  Nome
                </Item>
                <Item> Email </Item>
                <Item> Celular </Item>
                <Item>Data Cadastro</Item>
                <Item>Último Acesso</Item>
                <Item>Validade</Item>
                <Item>Progresso</Item>
              </Line>
              {listAlunos
                .sort((a, b) => ("" + a.nome).localeCompare(b.nome))
                .map((item, key) => (
                  <Line key={key}>
                    <Item> {item.id_pessoa} </Item>
                    <Item> {item.nome} </Item>
                    <Item> {item.email} </Item>
                    <Item> {item.celular} </Item>
                    <Item> {convertDate(item.data_cadastro)} </Item>
                    <Item> {convertDate(item.ultimo_acesso)} </Item>
                    <Item> {item.validade} </Item>
                    <Item> {item.progresso}% </Item>
                  </Line>
                ))}
            </Table>
            <Center style={{ padding: "1rem 0" }}>
              <Pagination
                boundaryRange={0}
                activePage={page}
                defaultActivePage={1}
                onPageChange={(e, f) => setPage(f.activePage)}
                firstItem={null}
                lastItem={null}
                totalPages={totalPages}
              />
            </Center>
            {/* <Space /> */}
          </>
        ) : loading ? (
          <Loading />
        ) : null}
      </Container>
    </div>
  );
};

export default DadosAlunosCursoStatus;
